import React from 'react';
import { MetricCard, type MetricTone } from '../MetricCards';

export interface AccountMetric {
  key: string;
  label: string;
  value: React.ReactNode;
  icon: string;
  tone: MetricTone;
  /** Tooltip for a figure that is shortened or needs a plain-words note. */
  title?: string;
}

/**
 * The row of metric cards on top of an account-level page: the same MetricCard
 * and grid the project pages use (VenueMetrics and the rest). A page passes the
 * figures; it renders nothing for an empty list so a card never reads "0" for
 * data that did not load.
 */
export const AccountMetrics: React.FC<{ label: string; metrics: AccountMetric[]; /** One line on the whole row, e.g. that it follows the header search. */ title?: string }> = ({ label, metrics, title }) => {
  if (metrics.length === 0) return null;
  return (
    <section className="stats-grid" aria-label={label} title={title}>
      {metrics.map(m => (
        <MetricCard key={m.key} label={m.label} value={m.value} icon={m.icon} tone={m.tone} title={m.title} />
      ))}
    </section>
  );
};

export default AccountMetrics;
